import { render, staticRenderFns } from "./ShortageList.vue?vue&type=template&id=29f9b360"
import script from "./ShortageList.vue?vue&type=script&lang=js"
export * from "./ShortageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports